export default "__VITE_ASSET__Bdr6IPVv__"